import { FilterService } from '@primevue/core/api';

// Matchmode voor array-velden (bijv. marktsegmenten): een rij matcht zodra het veld
// minstens één van de geselecteerde waarden bevat. Zo blijft meer aanvinken = meer
// resultaten (OR), consistent met hoe 'in' zich voor scalaire velden gedraagt.
export const CONTAINS_ANY_MATCH_MODE = 'containsAny';

FilterService.register(CONTAINS_ANY_MATCH_MODE, (value: unknown, filter: unknown): boolean => {
  if (filter === undefined || filter === null || (Array.isArray(filter) && !filter.length)) {
    return true;
  }

  const values = Array.isArray(value) ? value : [value];
  const selected = Array.isArray(filter) ? filter : [filter];

  return selected.some((s) => values.includes(s));
});
